/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Audio_AInputs */

const en_road_dude_faq_audio_a = /** @type {(inputs: Road_Dude_Faq_Audio_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The preset asks the video model to generate new English dialogue. Timing and pronunciation can vary. Review the output before sharing, and use audio you have permission to reuse if you edit it in afterward.`)
};

const zh_road_dude_faq_audio_a = /** @type {(inputs: Road_Dude_Faq_Audio_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板会请模型重新生成英文对白，语速和发音会因成片而异。发布前建议试听。如果后期添加原声，请使用你有权使用的音频。`)
};

/**
* | output |
* | --- |
* | "The preset asks the video model to generate new English dialogue. Timing and pronunciation can vary. Review the output before sharing, and use audio you have..." |
*
* @param {Road_Dude_Faq_Audio_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_audio_a = /** @type {((inputs?: Road_Dude_Faq_Audio_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Audio_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_audio_a(inputs)
	return zh_road_dude_faq_audio_a(inputs)
});
export { road_dude_faq_audio_a as "road_dude.faq.audio.a" }